<template>
  <div class="animated fadeIn">    
    <b-card>
      <form @submit.prevent="validate">
          <div class="form-row justify-content-start">
              <div class="col-sm-12 col-md-3">
                  <div class="form-group selectpicker" data-live-search="true">
                      <label>Evento</label>
                      <v-wait for="loading-event">
                          <template slot="waiting">
                          <input disabled type="text" value="Aguarde..." class="form-control" />
                          </template>
                          <select :class="{'custom-select': true}" v-model="tpvRequest.eventId">
                          <option
                              v-for="(s, index) in events"
                              :key="index"
                              :value="s.id"
                          >{{s.name}}</option>
                          </select>
                      </v-wait> 
                  </div>
              </div>                               
              <div class="col-md-2">
                  <div class="form-group">
                      <label>Início</label>
                      <datepicker
                          :language="languages.ptBR"
                          :bootstrapStyling="true"
                          placeholder="Início"
                          :calendar-button="true"
                          calendar-button-icon="fa fa-calendar"
                          v-model="tpvRequest.startDate"
                      ></datepicker>
                  </div>
              </div>                    
              <div class="col-md-2">
                  <div class="form-group">
                      <label>Término</label>
                      <datepicker
                          :language="languages.ptBR"
                          :bootstrapStyling="true"
                          placeholder="Termino"
                          :calendar-button="true"
                          calendar-button-icon="fa fa-calendar"
                          v-model="tpvRequest.endDate"
                      ></datepicker>
                  </div>
              </div>                    
          </div>
          <input type="submit" class="btn btn-primary" value="Buscar" />
      </form>
  </b-card>
    <b-card>
      <b-row>
        <b-col sm="5">
          <h4 id="traffic" class="card-title mb-0">Total de vendas</h4>
          <div class="small text-muted">{{ currentMonth }}</div>
        </b-col>
        <b-col sm="7" class="d-none d-md-block">
          <b-button type="button" variant="primary" class="float-right"><i class="icon-cloud-download"></i></b-button>
          <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
            <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="secondary" v-model="selected" name="radiosBtn">
              <b-form-radio class="mx-0" value="day">Dia</b-form-radio>
              <b-form-radio class="mx-0" value="month">Mês</b-form-radio>
              <b-form-radio class="mx-0" value="year">Ano</b-form-radio>
            </b-form-radio-group>
          </b-button-toolbar>
        </b-col>
      </b-row>
      <main-chart-example chartId="main-chart-01" class="chart-wrapper" style="height:300px;margin-top:40px;" v-model="tpvRequest"></main-chart-example>
      <div slot="footer">
        <b-row class="text-center">
          <b-col class="mb-sm-2 mb-0">
            <div>Total de Vendas</div>
            <strong>{{totalSales}}</strong>            
          </b-col>
          <b-col class="mb-sm-2 mb-0 d-md-down-none">
            <div>Total de descontos</div>
            <strong>{{totalDiscount}}</strong>            
          </b-col>
          <b-col class="mb-sm-2 mb-0">
            <div>Total de cancelamentos</div>
            <strong>{{totalCancelled}}</strong>            
          </b-col>          
        </b-row>
      </div>
    </b-card>
    <b-card>
      <b-table
          :items="tpvListResult"
          :fields="fields"
          :striped="true"
          responsive
      >                
        <template #cell(total)="data">{{formatDecimal(data.value)}}</template>
        <template #cell(cancelled)="data">{{formatDecimal(data.value)}}</template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import "vue-search-select/dist/VueSearchSelect.css";
import Datepicker from "vuejs-datepicker";
import MainChartExample from './MainChartExample'
import { Callout } from '@coreui/vue'
import dashboardPage from './dashboardPage';
import barOrderService from '../../services/BarOrders/BarOrderService';
import eventService from '../../services/Events/EventService';
import eventBus from '../../eventBus';
export default {
  name: 'dashboard',
  inheritAttrs: false,
  mixins: [dashboardPage],
  components: {
    Callout,
    MainChartExample,
    Datepicker
  },
  data: function () {
    return {
      tpvRequest: {
          startDate: new Date(),
          endDate: new Date(),
          eventId: null,
          machineSerial: '',
          userId: null
      },
      selected: 'day',
      tpvResult: {
        total: 0,
        discount: 0,
        cancelled: 0,
      },
      tpvListResult: [],
      events: [],
      fields:[                
        { key: "eventName", label: "Nome", sortable: false },
        { key: "total", label: "Total", sortable: false },
        { key: "cancelled", label: "Cancelados", sortable: false },        
        // { key: "actions", label: "" }               
      ],
    }      
  },
  computed: {
    totalSales() {
      return this.formatDecimal(this.tpvResult.total);
    },
    totalDiscount() {
      return this.formatDecimal(this.tpvResult.discount);
    },
    totalCancelled() {
      return this.formatDecimal(this.tpvResult.cancelled);
    },
    currentMonth() {
      return this.formatMonthYear(new Date());
    }
  },
  mounted() {
          
  },
  async created() {
    await this.fetchEventsData();
    this.fetchTpvData();
    this.fetchTpvListData();
  },
  methods: {    
    async fetchEventsData() {
        this.$wait.start("loading-events");      
        let response = await eventService.getAll();
        this.events = response.status == 204 ? [] : response.data;
        // if(this.events.length > 0) {
        //     this.tpvRequest.eventId = this.events[0].id;
        // }
        // else {
        //     this.events.unshift({ id: null, name: "Todos" });
        // }
        this.events.unshift({ id: null, name: "Todos" });
        this.$wait.end("loading-events");  
    },
    validate() {
      eventBus.$emit(`dashboard-filter:search`);
      this.fetchTpvData();
      this.fetchTpvListData();
    },
    fetchTpvData() {
      const self = this;
      this.showLoading();
      barOrderService.getTpv(this.tpvRequest)
      .then(
          (response) => {
              self.resetTpvResult();
              if(response.status == 200) {
                  self.tpvResult = response.data;
              }
              self.hideLoading();
          },
          () => {              
              self.hideLoading();
          }
      );
    },
    fetchTpvListData() {
      const self = this;
      this.showLoading();
      barOrderService.getTpvList(this.tpvRequest)
      .then(
          (response) => {              
              if(response.status == 200) {
                  self.tpvListResult = response.data;
              }
              self.hideLoading();
          },
          () => {              
              self.hideLoading();
          }
      );
    },
    resetTpvResult() {
      this.tpvResult.subTotal = 0;
      this.tpvResult.discount = 0;
      this.tpvResult.cancelled = 0;
      this.tpvResult.total = 0;
    },
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>